// Allowance / deduction rows created automatically by the backend (attendance
// sync, payroll generation, leave, advancements, imports) store an English
// description such as "Absent on 2026-10-01". The stored text is left as-is
// (other code relies on it); this only translates it for display when the UI
// is Arabic. Unknown / manually typed descriptions are returned unchanged.

const LATE_LABELS_AR = {
  "Late": "تأخير",
  "HalfDay(AM) Late": "تأخير (نصف يوم صباحي)",
  "HalfDay(PM) Late": "تأخير (نصف يوم مسائي)",
};

const RULES = [
  // "Absent on 2026-10-01"
  [/^Absent on (\d{4}-\d{2}-\d{2})$/i, (m) => `غياب يوم ${m[1]}`],
  // "Missing check-out on 2026-10-01"
  [/^Missing check-out on (\d{4}-\d{2}-\d{2})$/i, (m) => `عدم تسجيل انصراف يوم ${m[1]}`],
  // "Late 15min on 2026-10-01 | tier 2 | rule {...}"
  [
    /^(HalfDay\(AM\) Late|HalfDay\(PM\) Late|Late) (\d+)min on (\d{4}-\d{2}-\d{2})(?: \| tier ([^|]+?))?(?: \| rule .*)?$/,
    (m) => `${LATE_LABELS_AR[m[1]] || "تأخير"} ${m[2]} دقيقة يوم ${m[3]}${m[4] ? ` — الشريحة ${m[4].trim()}` : ""}`,
  ],
  // "Net undertime 30min (cycle total OT=10 UT=40)"
  [
    /^Net undertime (\d+)min \(cycle total OT=(\d+) UT=(\d+)\)$/i,
    (m) => `صافي ساعات العجز ${m[1]} دقيقة (إجمالي الدورة: إضافي ${m[2]} دقيقة، عجز ${m[3]} دقيقة)`,
  ],
  // "25% sick leave deduction for 3 day(s) above 15 annual sick days - Leave #12"
  [
    /^25% sick leave deduction for (\d+) day\(s\) above (\d+) annual sick days - Leave #(\d+)$/i,
    (m) => `خصم 25% إجازة مرضية عن ${m[1]} يوم بعد تجاوز ${m[2]} يوم مرضي سنويًا - طلب إجازة #${m[3]}`,
  ],
  // "New comer: 5 day(s) before hire date (2026-10-06), cycle starts 2026-10-01"
  [
    /^New comer: (\d+) day\(s\) before hire date \((\d{4}-\d{2}-\d{2})\), cycle starts (\d{4}-\d{2}-\d{2})$/i,
    (m) => `موظف جديد: ${m[1]} يوم قبل تاريخ التعيين (${m[2]})، بداية الدورة ${m[3]}`,
  ],
  // "Medical Insurance — 3 member(s) — 900.00 EGP/month"
  [
    /^Medical Insurance — (\d+) member\(s\) — ([\d,.]+) EGP\/month$/i,
    (m) => `التأمين الطبي — ${m[1]} فرد — ${m[2]} جنيه/شهر`,
  ],
  // "Advancement #7 — Installment 2/6"
  [
    /^Advancement #(\d+) — Installment (\d+)\/(\d+)$/i,
    (m) => `سلفة #${m[1]} — القسط ${m[2]} من ${m[3]}`,
  ],
  // "Imported from column: Bonus"
  [/^Imported from column: (.+)$/i, (m) => `مستورد من العمود: ${m[1]}`],
  // "Imported from column "OT": 3 × hour(55.20) × 1.5 = 248.40 EGP"
  [/^Imported from column "(.+?)": (.+?) EGP$/i, (m) => `مستورد من العمود "${m[1]}": ${m[2]} جنيه`],
  [/^Transportation Allowance$/i, () => "بدل انتقالات"],
];

export const localizeAdjustmentDescription = (description, isRTL) => {
  if (!description || !isRTL) return description;
  const text = String(description).trim();
  for (const [re, render] of RULES) {
    const m = text.match(re);
    if (m) return render(m);
  }
  return description;
};
